import React, { useState, useEffect, act } from "react";
import "../Orders/Orders.css";
import "../Inventory/Inventory.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import Paper from "@mui/material/Paper";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import { GoSearch } from "react-icons/go";
import { axiosInstance } from "../../../axiosInstance";
import Modal from "react-bootstrap/Modal";
import { AiOutlineDelete } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { useFormik } from "formik";
import * as yup from "yup";

let addValidationSchema = yup.object({
  customer_name: yup.string().required("Customer name is required"),

  mobile: yup
    .string()
    .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits")
    .required("Mobile number is required"),

  email: yup.string().email("Invalid email"),
  address: yup.string().required("Address is requied"),
  city: yup
    .string()
    .required("City is required")
    .matches(/^[A-Za-z\s]+$/, "Only letters are allowed"),
  district: yup
    .string()
    .required("District is required")
    .matches(/^[A-Za-z\s]+$/, "Only letters are allowed"),
  state: yup
    .string()
    .required("State is required")
    .matches(/^[A-Za-z\s]+$/, "Only letters are allowed"),
  pincode: yup.string().required("Pincode is required"),
});
let editValidationSchema = yup.object({
  customer_name: yup.string().required("Customer name is required"),

  mobile: yup
    .string()
    .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits")
    .required("Mobile number is required"),

  email: yup.string().email("Invalid email"),
  address: yup.string().required("Address is requied"),
  city: yup
    .string()
    .required("City is required")
    .matches(/^[A-Za-z\s]+$/, "Only letters are allowed"),
  district: yup
    .string()
    .required("District is required")
    .matches(/^[A-Za-z\s]+$/, "Only letters are allowed"),
  state: yup
    .string()
    .required("State is required")
    .matches(/^[A-Za-z\s]+$/, "Only letters are allowed"),
  pincode: yup.string().required("Pincode is required"),
});

export const SubCustomer = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // add customer modal
  const [addshow, setAddShow] = useState(false);

  const handleAddClose = () => setAddShow(false);
  const handleAddShow = () => setAddShow(true);

  // edit customer modal
  const [editshow, setEditShow] = useState(false);
  const [editCustomerId, setEditCustomerId] = useState("");

  const handleEditClose = () => setEditShow(false);
  const handleEditShow = (id) => {
    setEditShow(true);
    setEditCustomerId(id);
    FetchEachCustomerDetails(id);
  };

  // delete customer modal
  const [deleteshow, setDeleteShow] = useState(false);
  const [customerDeleteId, setCustomerDeleteId] = useState("");

  const handleDeleteClose = () => setDeleteShow(false);
  const handleDeleteShow = (id) => {
    setDeleteShow(true);
    setCustomerDeleteId(id);
  };

  // order list table pagination
  const [page, setPage] = useState(() => {
    const savedPage = sessionStorage.getItem("customer_page");
    return savedPage ? Number(savedPage) : 0;
  });
  const [rowsPerPage, setRowsPerPage] = useState(() => {
    const savedRows = sessionStorage.getItem("customer_rowsPerPage");
    return savedRows ? Number(savedRows) : 5;
  });
  const [totalCount, setTotalCount] = useState(0);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0); // reset to first page
    sessionStorage.setItem("customer_rowsPerPage", +event.target.value);
    sessionStorage.setItem("customer_page", 0);
  };

  const [searchText, setSearchText] = useState("");
  const [customersList, setCustomersList] = useState({});

  async function FetchCustomersList() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: page + 1, // atleast 1 page
          page_size: rowsPerPage,
          search: searchText,
        },
      };
      const response = await axiosInstance.get("/customers/", config);
      if (response.data.status === "success" || response.status === 200) {
        setCustomersList(response.data?.data);
        setTotalCount(response.data?.data.count);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to fetch order list");
      console.log("Failed to fetch order list");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    FetchCustomersList();
  }, [page, rowsPerPage]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (page !== 0) {
        setPage(0);
      } else {
        FetchCustomersList();
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchText]);

  // CLEAR FILTERS
  function handleClearFilters() {
    setSearchText("");
  }

  // RESET Search

  function handleReset() {
    setSearchText("");
  }
  const formik = useFormik({
    initialValues: {
      customer_name: "",
      mobile: "",
      email: "",
      address: "",
      city: "",
      district: "",
      state: "",
      pincode: "",
      state_code: 0,
      gstin: "",
      pan_number: "",
    },
    validationSchema: editValidationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        const response = await axiosInstance.post("/customers/", values);
        if (response.data.status === "success" || response.status === 200) {
          toast.success(response.data.message || "Customer added successfully");
          resetForm();
          FetchCustomersList();
          handleAddClose();
        }
      } catch (error) {
        toast.error(
          error.response.data.message || "Failed to add customer details",
        );
        console.log("Failed to add customer details");
      } finally {
        setLoading(false);
      }
    },
  });

  async function FetchEachCustomerDetails(id) {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/customers/${id}`);
      if (response.data.status === "success" || response.status === 200) {
        const data = response.data?.data;
        editformik.setValues({
          customer_name: data.customer_name || "",
          mobile: data.mobile || "",
          email: data.email || "",
          address: data.address || "",
          city: data.city || "",
          district: data.district || "",
          state: data.state || "",
          pincode: data.pincode || "",
          state_code: data.state_code || "0",
          gstin: data.gstin || "",
          pan_number: data.pan_number || "",
        });
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }
  const editformik = useFormik({
    initialValues: {
      customer_name: "",
      mobile: "",
      email: "",
      address: "",
      city: "",
      district: "",
      state: "",
      pincode: "",
      state_code: 0,
      gstin: "",
      pan_number: "",
    },
    validationSchema: editValidationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        const response = await axiosInstance.patch(
          `/customers/${editCustomerId}/`,
          values,
        );
        if (response.data.status === "success" || response.status === 200) {
          toast.success(
            response.data.message || "Customer update successfully",
          );
          resetForm();
          FetchCustomersList();
          handleEditClose();
        }
      } catch (error) {
        toast.error(
          error.response.data.message || "Failed to update customer details",
        );
        console.log("Failed to update customer details");
      } finally {
        setLoading(false);
      }
    },
  });

  async function handleDeleteCustomer() {
    try {
      setLoading(true);
      const response = await axiosInstance.delete(
        `/customers/${customerDeleteId}/`,
      );
      if (response.data.status === "success" || response.status === 200) {
        toast.success(response.data.message || "customer deleted successfully");
        FetchCustomersList();
        handleDeleteClose();
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to delete customer details",
      );
      console.log("Failed to delete customer details");
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="ordersContainer">
        <div className="container">
          <div className="dashboardTitleContainer">
            <div>
              <div className="inventoryTitle">Customers</div>
              <div className="inventorySubtitle">
                All your customer information in one place
              </div>
            </div>
            <div className="addButtonContainer">
              <div className="inventoryBtnReorder">
                <button onClick={handleAddShow}>New Customer</button>
              </div>
            </div>
          </div>

          <div className="searchMainContainer">
            <div className="searchSubContainer">
              <div className="searchGrid">
                <div>
                  <input
                    type="text"
                    placeholder="Search"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
                <div style={{ display: "flex", gap: "5px" }}>
                  <div>
                    <GoSearch className="searchIcon" />
                  </div>
                  <div className="btnRestSearch">
                    <button onClick={handleReset}>Reset</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {searchText && (
            <div className="filterResultsContainer">
              <div>
                <span style={{ color: "var(--color-font-primary)" }}>
                  Showing Results Of:
                </span>

                {searchText && (
                  <>
                    {" "}
                    &nbsp; <strong>Search:</strong> {searchText}{" "}
                  </>
                )}
              </div>

              <div
                style={{
                  cursor: "pointer",
                  color: "var(--color-font-primary)",
                }}
                onClick={handleClearFilters}
              >
                <span className="me-1">
                  <IoClose />
                </span>
                Clear Filters
              </div>
            </div>
          )}

          {/* table  */}
          <div className="titleOrderList">Customers List</div>
          <div>
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 1200 }}
                stickyHeader
                aria-label="sticky table"
              >
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell align="left">Customer Name</TableCell>
                    <TableCell align="left">Phone Number</TableCell>
                    <TableCell align="left">Email</TableCell>
                    <TableCell align="left">Address</TableCell>
                    <TableCell align="left">City</TableCell>
                    <TableCell align="left">District</TableCell>
                    <TableCell align="left">State</TableCell>
                    <TableCell align="left">Pincode</TableCell>
                    <TableCell align="left">State Code</TableCell>
                    <TableCell align="left">GSTIN</TableCell>
                    <TableCell align="left">Pan Number</TableCell>
                    <TableCell align="left">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {customersList?.results?.length > 0 ? (
                    customersList.results.map((row) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        className="dashboardTableBody"
                      >
                        <TableCell component="th" scope="row">
                          {row.customer_name || "---"}
                        </TableCell>
                        <TableCell align="left">
                          {row.mobile ?? "---"}
                        </TableCell>
                        <TableCell align="left">{row.email || "---"}</TableCell>
                        <TableCell align="left">
                          {row.address || "---"}
                        </TableCell>
                        <TableCell align="left">{row.city || "---"}</TableCell>
                        <TableCell align="left">
                          {row.district || "---"}
                        </TableCell>
                        <TableCell align="left">{row.state || "---"}</TableCell>
                        <TableCell align="left">
                          {row.pincode || "---"}
                        </TableCell>
                        <TableCell align="left">
                          {row.state_code || "0"}
                        </TableCell>
                        <TableCell align="left">{row.gstin || "---"}</TableCell>
                        <TableCell align="left">
                          {row.pan_number || "---"}
                        </TableCell>

                        <TableCell align="left">
                          <div className="d-flex gap-3">
                            <span
                              onClick={() => handleEditShow(row.id)}
                              style={{ cursor: "pointer" }}
                            >
                              <FiEdit />
                            </span>
                            <span onClick={() => handleDeleteShow(row.id)}>
                              <AiOutlineDelete />
                            </span>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        align="center"
                        style={{ padding: "20px" }}
                      >
                        Data not available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={totalCount}
              page={page}
              onPageChange={(event, newPage) => {
                setPage(newPage);
                sessionStorage.setItem("customer_page", newPage);
              }}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[5, 10, 20, 50]} //dropdown
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>

          {/* customer add modal  */}
          <div>
            <Modal
              show={addshow}
              onHide={handleAddClose}
              centered
              size="lg"
              className="addModal"
            >
              <form onSubmit={formik.handleSubmit}>
                <Modal.Header closeButton>
                  <Modal.Title className="addModalTitle">
                    Add Customer Details
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="bulkAddGrid">
                    <div>
                      <label>
                        Customer Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Customer Name"
                        name="customer_name"
                        value={formik.values.customer_name}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.customer_name &&
                        formik.touched.customer_name && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {formik.errors.customer_name}
                          </div>
                        )}
                    </div>
                    <div>
                      <label>
                        Phone Number <span className="text-danger">*</span>
                      </label>

                      <input
                        type="text"
                        placeholder="Enter Phone Number"
                        maxLength={10}
                        name="mobile"
                        value={formik.values.mobile}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.mobile && formik.touched.mobile && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.mobile}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="bulkAddGrid">
                    <div>
                      <label>Email</label>
                      <input
                        type="text"
                        placeholder="Enter Email"
                        name="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.email && formik.touched.email && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.email}
                        </div>
                      )}
                    </div>

                    <div>
                      <label>Address <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        placeholder="Enter Address"
                        name="address"
                        value={formik.values.address}
                        onChange={formik.handleChange}
                      />
                         {formik.errors.address && formik.touched.address && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.address}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="bulkAddGrid">
                    <div>
                      <label>City <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        placeholder="Enter City"
                        name="city"
                        value={formik.values.city}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.city && formik.touched.city && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.city}
                        </div>
                      )}
                    </div>
                    <div>
                      <label>District <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        placeholder="Enter District"
                        name="district"
                        value={formik.values.district}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.district && formik.touched.district && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.district}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="bulkAddGrid">
                    <div>
                      <label>State <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        placeholder="Enter State"
                        name="state"
                        value={formik.values.state}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.state && formik.touched.state && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.state}
                        </div>
                      )}
                    </div>
                    <div>
                      <label>Pin Code <span className="text-danger">*</span></label>
                      <input
                        type="number"
                        placeholder="Enter Pincode"
                        name="pincode"
                        value={formik.values.pincode}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.pincode && formik.touched.pincode && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.pincode}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="bulkAddGrid">
                    <div>
                      <label>State Code</label>
                      <input
                        type="number"
                        placeholder="Enter State Code"
                        name="state_code"
                        value={formik.values.state_code}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.state_code &&
                        formik.touched.state_code && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {formik.errors.state_code}
                          </div>
                        )}
                    </div>
                    <div>
                      <label>GSTIN</label>
                      <input
                        type="text"
                        placeholder="Enter GSTIN"
                        name="gstin"
                        value={formik.values.gstin}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.gstin && formik.touched.gstin && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.gstin}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="bulkAddGrid">
                    <div>
                      <label>Pan Number</label>
                      <input
                        type="text"
                        placeholder="Enter Pan Number"
                        name="pan_number"
                        value={formik.values.pan_number}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.pan_number &&
                        formik.touched.pan_number && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {formik.errors.state_code}
                          </div>
                        )}
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    className="addBtnCancel"
                    type="button"
                    onClick={handleAddClose}
                  >
                    Cancel
                  </button>
                  <button className="addBtnSave" type="submit">
                    {" "}
                    Submit
                  </button>
                </Modal.Footer>
              </form>
            </Modal>
          </div>
          {/* customer edit modal  */}
          <div>
            <Modal
              show={editshow}
              onHide={handleEditClose}
              centered
              size="lg"
              className="addModal"
            >
              <form onSubmit={editformik.handleSubmit}>
                <Modal.Header closeButton>
                  <Modal.Title className="addModalTitle">
                    Edit Customer Details
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="bulkAddGrid">
                    <div>
                      <label>
                        Customer Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Customer Name"
                        name="customer_name"
                        value={editformik.values.customer_name}
                        onChange={editformik.handleChange}
                      />
                      {editformik.errors.customer_name &&
                        editformik.touched.customer_name && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {editformik.errors.customer_name}
                          </div>
                        )}
                    </div>
                    <div>
                      <label>
                        Phone Number <span className="text-danger">*</span>
                      </label>

                      <input
                        type="text"
                        placeholder="Enter Phone Number"
                        maxLength={10}
                        name="mobile"
                        value={editformik.values.mobile}
                        onChange={editformik.handleChange}
                      />
                      {editformik.errors.mobile &&
                        editformik.touched.mobile && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {editformik.errors.mobile}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="bulkAddGrid">
                    <div>
                      <label>Email</label>
                      <input
                        type="text"
                        placeholder="Enter Email"
                        name="email"
                        value={editformik.values.email}
                        onChange={editformik.handleChange}
                      />
                      {editformik.errors.email && editformik.touched.email && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {editformik.errors.email}
                        </div>
                      )}
                    </div>

                    <div>
                      <label>Address <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        placeholder="Enter Address"
                        name="address"
                        value={editformik.values.address}
                        onChange={editformik.handleChange}
                      />
                         {editformik.errors.address && editformik.touched.address && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {editformik.errors.address}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="bulkAddGrid">
                    <div>
                      <label>City <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        placeholder="Enter City"
                        name="city"
                        value={editformik.values.city}
                        onChange={editformik.handleChange}
                      />
                      {editformik.errors.city && editformik.touched.city && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {editformik.errors.city}
                        </div>
                      )}
                    </div>
                    <div>
                      <label>District <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        placeholder="Enter District"
                        name="district"
                        value={editformik.values.district}
                        onChange={editformik.handleChange}
                      />
                      {editformik.errors.district &&
                        editformik.touched.district && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {editformik.errors.district}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="bulkAddGrid">
                    <div>
                      <label>State <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        placeholder="Enter State"
                        name="state"
                        value={editformik.values.state}
                        onChange={editformik.handleChange}
                      />
                      {editformik.errors.state && editformik.touched.state && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {editformik.errors.state}
                        </div>
                      )}
                    </div>
                    <div>
                      <label>Pin Code <span className="text-danger">*</span></label>
                      <input
                        type="number"
                        placeholder="Enter Pincode"
                        name="pincode"
                        value={editformik.values.pincode}
                        onChange={editformik.handleChange}
                      />
                      {editformik.errors.pincode &&
                        editformik.touched.pincode && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {editformik.errors.pincode}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="bulkAddGrid">
                    <div>
                      <label>State Code</label>
                      <input
                        type="number"
                        placeholder="Enter State Code"
                        name="state_code"
                        value={editformik.values.state_code}
                        onChange={editformik.handleChange}
                      />
                      {editformik.errors.state_code &&
                        editformik.touched.state_code && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {editformik.errors.state_code}
                          </div>
                        )}
                    </div>
                    <div>
                      <label>GSTIN</label>
                      <input
                        type="text"
                        placeholder="Enter GSTIN"
                        name="gstin"
                        value={editformik.values.gstin}
                        onChange={editformik.handleChange}
                      />
                      {editformik.errors.gstin && editformik.touched.gstin && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {editformik.errors.gstin}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="bulkAddGrid">
                    <div>
                      <label>Pan Number</label>
                      <input
                        type="text"
                        placeholder="Enter Pan Number"
                        name="pan_number"
                        value={editformik.values.pan_number}
                        onChange={editformik.handleChange}
                      />
                      {editformik.errors.pan_number &&
                        editformik.touched.pan_number && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {editformik.errors.pan_number}
                          </div>
                        )}
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    className="addBtnCancel"
                    type="button"
                    onClick={handleEditClose}
                  >
                    Cancel
                  </button>
                  <button className="addBtnSave" type="submit">
                    {" "}
                    Update
                  </button>
                </Modal.Footer>
              </form>
            </Modal>
          </div>
          {/* customer delete modal  */}
          <Modal
            show={deleteshow}
            onHide={handleDeleteClose}
            centered
            className="paymentModal"
          >
            <Modal.Header closeButton style={{ borderBottom: "none" }}>
              {/* <Modal.Title>Cancel Order</Modal.Title> */}
            </Modal.Header>
            <Modal.Body>
              <div className="cancelOrderTitle">
                Are you sure want to delete customer details?
              </div>

              <div className="cancelOrderBtnContainer">
                <div className="paymentBtnCancel">
                  <button onClick={handleDeleteClose} type="button">
                    Close
                  </button>
                </div>
                <div className="paymentBtnConfirm">
                  <button onClick={handleDeleteCustomer}>Delete</button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </>
  );
};
